<template>
    <el-input type="tel" :minlength="位数" :maxlength="位数" :placeholder="placeholder" :value="value" @input="$emit('input', $event)" autocomplete="off">
        <el-button slot="append" :disabled="获取验证码倒计时>0" @click="$emit('onGet', start, $event)">{{验证码按钮文字}}</el-button>
    </el-input>
</template>

<script>
export default {
    name:'elCode',
    props: {
        位数: {
            default: 6
        },
        value: {
            default: '',
        },
        placeholder:{
            default: '请输入验证码',
        },
        buttonText:{
            default: '获取验证码',
        },
    },
    data() {
        return {
            获取验证码倒计时: 0,
            验证码按钮文字: this.buttonText,
        }
    },
    mounted() {
        this.获取验证码倒计时 = 0;
        this.验证码按钮文字 = this.buttonText;
    },
    methods: {
        djs() {
            if (this.获取验证码倒计时 > 0) {
                this.获取验证码倒计时--;
                this.验证码按钮文字 = '(' + this.获取验证码倒计时 + ')秒后重新获取';
                setTimeout(this.djs, 1000);
            } else {
                this.获取验证码倒计时 = 0;
                this.验证码按钮文字 = this.buttonText;
            }
        },
        start() {
            this.获取验证码倒计时 = 60;
            this.验证码按钮文字 = '(' + this.获取验证码倒计时 + ')秒后重新获取';
            setTimeout(this.djs, 1000);
        }
    },
}
</script>

<style scoped>
</style>